import React from 'react';
import { Icon } from 'antd';
import cn from 'classnames';
import styles from './QuestionReactionIcon.module.scss';

const QuestionReactionIcon = ({ reactionName }) => {
  return (
    <Icon
      className={cn(styles.root, styles[reactionName])}
      type={reactionName}
      theme="filled"
    />
  );
};

export default QuestionReactionIcon;
